<script setup lang="ts">
import { computed, useAttrs, type Slot } from 'vue'
import type { FdsLabelProps } from './types'
import { classValueToString } from '../../../helpers/classValueToString'

defineOptions({
  inheritAttrs: false,
})

const props = withDefaults(defineProps<FdsLabelProps>(), {
  dataTestid: undefined,
})

const attrs = useAttrs()

const consumerClass = computed(() => classValueToString(attrs.class))

const rootAttrs = computed(() => {
  const result: Record<string, unknown> = { ...attrs }
  delete result.class
  if (props.dataTestid) {
    result['data-testid'] = props.dataTestid
  }
  return result
})

defineSlots<{
  default?: Slot
}>()

const spanClasses = computed(() => {
  const baseClasses = 'font-bold inline-block mb-2 tracking-wide'
  return [baseClasses, consumerClass.value].filter(Boolean).join(' ')
})
</script>

<template>
  <span :class="spanClasses" v-bind="rootAttrs">
    <slot />
  </span>
</template>
